import React from "react";
import ReactDOM from "react-dom";
import {
  MasterProvider,
  Router,
  serviceWorker,
} from "@westcut/lib-client-common";
import { env } from "./env";
import { Dashboard } from "./Layout/Dashboard";
import { DataProvider } from "./Provider/Data";
import { routes } from "./routes";

ReactDOM.render(
  <React.StrictMode>
    <MasterProvider uri={env.REACT_APP_API_URL}>
      <Dashboard>
        <DataProvider>
          <Router routes={routes} />
        </DataProvider>
      </Dashboard>
    </MasterProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
